@if (isLoading) {
    <mat-spinner></mat-spinner>
} @else {
    <div fusePerfectScrollbar fxLayout="column" id="login">

        @if (!this.modeSSO) {
            <div fxLayout="column" fxLayoutAlign="center center" id="login-form-wrapper">
                <div *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }" id="login-form">
                    @if (settings.displayLoginLogo) {
                        <app-login-logo></app-login-logo>
                    }

                    @if (settings.displayPartnersLogo?.length > 0) {
                        <app-partners-logos [partnerLogos]="settings.displayPartnersLogo"></app-partners-logos>
                    }

                    @if (displaySessions) {
                        <app-sessions-list (loginSession)="onLoginSession($event)"></app-sessions-list>
                        <app-register-link></app-register-link>
                    } @else {
                        <app-gar-login></app-gar-login>

                        @if (settings.enableGAR && displayGARHelper && settings.enableFormLogin && entButtonAllowed) {
                            <div class="divider">
                                <span>
                                    {{ "generic.or" | translate }}
                                </span>
                            </div>
                        }

                        @if (!settings.enableGAR || !displayGARHelper) {
                            <h2 class="title mat-headline-6">
                                {{ "authentication.title" | translate }}
                            </h2>
                        }

                        @if (settings.enableSSO) {
                            <h3 class="sso-description">
                                {{ "authentication.sso.learner" | translate }}
                            </h3>
                        }

                        @if (settings.enableFormLogin) {
                            <app-login-form [login]="forceLoginValue()"></app-login-form>
                        }

                        @if (settings.enableSSO) {
                            <app-sso-login></app-sso-login>
                        }
                    }


                </div>
            </div>
        } @else {
            <div
                fxLayout="column"
                fxLayoutAlign="center center"
                id="login-sso-wrapper"
            >
                <div id="login-sso">
                    @if (settings.displayLoginLogo) {
                        <app-login-logo></app-login-logo>
                    }
                    <h2>{{ "authentication.sso.in-progress" | translate }}</h2>
                </div>
            </div>
        }

    </div>
}